import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PopupLeadstatusRoutingModule } from './popup-leadstatus-routing.module';
import { PopupLeadstatusComponent } from './popup-leadstatus.component';
import { LeadDetailModule } from 'src/app/pages/crm/lead-detail/lead-detail.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedModule } from '../../shared.module';
import { CustomFlexLayoutModule } from '../../flex-layout/custom-flex-layout.module';
import { SimpleDynamicFormComponent } from '../../simple-form/simple-dynamic-form/simple-dynamic-form.component';
import { SimpleDynamicComponentModule } from '../../simple-form/simple-dynamic-component.module';


@NgModule({
  declarations: [
    PopupLeadstatusComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PopupLeadstatusRoutingModule,
    LeadDetailModule,
    MatIconModule,
    MatOptionModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatFormFieldModule,
    SharedModule,
   CustomFlexLayoutModule,
   SimpleDynamicComponentModule
  ],
  exports:[PopupLeadstatusComponent]
})
export class PopupLeadstatusModule { }
